/**
 * Object that holds colors to use globally.
 */
export const GlobalColors = {
    errorRed: '#cb040b',
    white: '#ffffff',
};
